export type GlobalContextType = {
  seeToast: boolean;
  setSeeToast: React.Dispatch<React.SetStateAction<boolean>>;
  toastMsg: string;
  setToastMsg: React.Dispatch<React.SetStateAction<string>>;
  errorToast: boolean; 
  setErrorToast: React.Dispatch<React.SetStateAction<boolean>>;
};

let toastStore: GlobalContextType | null = null;

export const setToastStore = (ctx: GlobalContextType) => {
  toastStore = ctx;
};

export const getToastStore = () => toastStore;
